import React from "react";
import { Link } from "gatsby";

var Api_url = process.env.GATSBY_API_URL;
var url = Api_url + `/api/wm/yearwise/team/members/lists`;
console.log('API_URL=' + Api_url + ', url=' + url);

var image1 = Api_url + `/assets/website/images/coming-soon.png`;
console.log('image1=' + image1);

const Content = () => {
    return (
        <div className="footer-widget footer-widget__link mb-40">
            <h3 className="footer-widget__title">Quick Links</h3>
            <ul className="list-unstyled footer-widget__link-list">
                <li>
                    <Link to="/about-jci">About us</Link>
                </li>
                <li>
                    <Link to="/content/privacy-statement">Privacy and Policy</Link>
                </li>
                <li>
                    <Link to="/content/terms-of-service">Terms of service</Link>
                </li>
                <li>
                    <Link to="/content/return-and-refund-policy">Return & refund</Link>
                </li>
                <li>
                    <Link to="/online-payment">Payment</Link>
                </li>
                <li>
                    <a href="https://seniors.jciindia.in/" target="_blank">
                        Senior Members Association
                    </a>
                </li>
                <li>
                    <a href="https://foundation.jciindia.in/" target="_blank">
                        JCI India Foundation
                    </a>
                </li>
                <li>
                    <a target="_blank" href="https://members.jciindia.in/">
                        Members Portal Login
                    </a>
                </li>
                <li>
                    <Link to="/contact">Contact us</Link>
                </li>
            </ul>
        </div>
    );
};

export default Content;
